export default {
  BACKEND_URL (state) {
    return state.backendUrl
  },
  FRONTEND_URL (state) {
    return state.frontendUrl
  },
}